import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import { http } from '../../services/HttpInterceptor';
import { RouteComponentProps, Link, Redirect } from "react-router-dom";
import { toast } from 'react-toastify';
import { observable } from 'mobx';
import { sessionService } from '../../services/SessionService';

interface ChangeToYearlyInvoiceProps extends RouteComponentProps {
    changeToggle(action?: boolean): void
}

@observer export default class ChangeToYearlyInvoice extends React.Component<ChangeToYearlyInvoiceProps> {

    @observable private invoice: any;
    @observable private isLoaded = false;
    @observable private id: any = "";
    @observable private redirect: boolean = false;

    componentDidMount() {
        this.props.changeToggle(true);
        this.init();
    }

    init = () => {
        const match = this.props.match;
        const id = (match as any).params.id;
        this.id = id;
        http.get(`/api/invoice/read/${id}`).then((response) => {
            this.invoice = response.data;
            this.isLoaded = true;
        })
            .catch(() => {
                toast.error("Error cargando Recibo");
            });
    }

    //función para calcular el nuevo periodo hasta
    getNewPeriodTo = () => {
        if (!this.invoice.period_from) return '';
        const dateParts = this.invoice.period_from.split('-');
        if (dateParts.length !== 3) return '';
        const originalYear = parseInt(dateParts[0], 10);
        const originalMonth = parseInt(dateParts[1], 10);
        const originalDay = parseInt(dateParts[2], 10);
        const newYear = originalYear + 1;
        const lastDayOfMonth = new Date(newYear, originalMonth, 0).getDate();
        const newDay = Math.min(originalDay, lastDayOfMonth);
        const month = String(originalMonth).padStart(2, '0');
        const day = String(newDay).padStart(2, '0');
        return `${newYear}-${month}-${day}`;
    }

    onSubmitAnnual = (): void => {
        if (this.invoice.contract_id.toString().startsWith("W")) {
            this.invoice.contract_id = this.invoice.contract_id.substring(1);
        }

        let amount = this.invoice.amount.replace("$", "").replace(/,/g, "");
        const newAmount = Number(amount) * 11;
        const newPeriodTo = this.getNewPeriodTo();

        const data = {
            id: this.invoice.id,
            contract_id: this.invoice.contract_id,
            amount: newAmount,
            period_to: newPeriodTo,
            updated_by: sessionService.getUserInfo().id
        };

        http
            .post(`/api/invoice/change_to_annual`, JSON.stringify(data))
            .then(() => {
                toast.success(`Recibo actualizado a anual`);
                this.redirect = true;
            })
            .catch((error) => {
                if (Array.isArray(error)) {
                    error.forEach((val) => toast.error(val));
                } else {
                    toast.error(error);
                }
            });
    };

    render() {
        if (this.redirect) {
            return <Redirect to="/recibos" />;
        }

        if (!this.isLoaded) {
            return null;
        }

        return (
            <Fragment>
                <div className="row">
                    <div className="col-sm-12">
                        <div className="card">
                            <div className="card-header card-header-rose card-header-text">
                                <div className="card-text">
                                    <h4 className="card-title">Cambiar Recibo a Anual</h4>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-sm-10"></div>
                                    <div className="col-sm-2">
                                        <Link to={`../../recibos/ver/${this.id}`}>
                                            <button className="btn btn-danger btn-sm pull-right">
                                                <i className="material-icons">highlight_off</i>
                                                <div className="ripple-container"></div>
                                            </button>
                                        </Link>
                                    </div>
                                </div>
                                <div className="row">
                                    <label className="col-sm-4">Recibo #</label>
                                    <div className="col-sm-8">
                                        <strong>{this.invoice.id}</strong>
                                    </div>
                                </div>
                                <div className="row">
                                    <label className="col-sm-4">Cantidad (total original * 11)</label>
                                    <div className="col-sm-8">
                                        <strong>${this.invoice.amount * 11}</strong>
                                    </div>
                                </div>
                                <div className="row">
                                    <label className="col-sm-4">Desde</label>
                                    <div className="col-sm-8">
                                        <strong>{this.invoice.period_from}</strong>
                                    </div>
                                </div>
                                <div className="row">
                                    <label className="col-sm-4">Hasta</label>
                                    <div className="col-sm-8">
                                        <strong>{this.invoice.period_to}</strong>
                                    </div>
                                </div>
                                <div className="row">
                                    <label className="col-sm-4">Nuevo Periodo Hasta</label>
                                    <div className="col-sm-8">
                                        <strong>{this.getNewPeriodTo()}</strong>
                                    </div>
                                </div>
                                <div className="row" style={{ marginTop: '20px' }}>
                                    <div className="col-sm-12" style={{ textAlign: 'center' }}>
                                        <button 
                                            onClick={this.onSubmitAnnual} 
                                            className="btn btn-success btn-lg"
                                        >
                                            <i className="material-icons">check_circle</i> Cambio a Anual
                                            <div className="ripple-container"></div>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}